<template>
  <probe-list-table />
</template>

<script>
import ProbeListTable from "../../components/sensor/ProbeListTable";
export default {
  name: "StationErrorHistory",
  components: {
    'probe-list-table': ProbeListTable
  },
}
</script>

<style scoped>

</style>